import { lazy } from 'react';

import { retry } from 'app/utils/lib/file';

type ComponentProps = Record<string, unknown>;

const LazyBrokerCarrierMatchingDashboardRoute = lazy(() =>
  retry(() => import('app/pages/admin/BrokerCarrierMatching/Dashboard')));
const LazyBrokerCarrierMatchingNextRoute = lazy(() =>
  retry(() => import('app/pages/admin/BrokerCarrierMatching/Next')));
const LazyBrokerCarrierMatchingShowRoute = lazy(() =>
  retry(() => import('app/pages/admin/BrokerCarrierMatching/Show')));

export const BrokerCarrierMatchingDashboard = (props: ComponentProps) =>
  <LazyBrokerCarrierMatchingDashboardRoute {...props} />;
export const BrokerCarrierMatchingNext = (props: ComponentProps) =>
  <LazyBrokerCarrierMatchingNextRoute {...props} />;
export const BrokerCarrierMatchingShow = (props: ComponentProps) =>
  <LazyBrokerCarrierMatchingShowRoute {...props} />;
